<template>
  <div>
    <DxDataGrid ref="dataGrid" :allowColumnReordering="true" :data-source="{
      store: dsSalesProducts,
      filter: ['OfertaID', '=', offerId]
    }" :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnResizingMode="'nextColumn'"
      :show-borders="true" :syncLookupFilterValues="false" :filter-sync-enabled="true" :show-row-lines="true"
      :show-column-lines="false" :allowMerging="'Cells'" height="100%" class="grid theme-dependent"
      @exporting="onExporting" @init-new-row="onInitNewRow" @row-removing="onRowRemoving" @row-inserted="onRowInserted"
      :keyboard-navigation="{ enterKeyAction: 'save', enterKeyDirection: 'none', editOnKeyPress: true }">
      <DxSelection mode="single" />
      <DxScrolling :mode="'virtual'" />
      <DxColumnChooser :enabled="true" />
      <DxPaging :page-size="20" />
      <DxSorting mode="multiple" />
      <DxHeaderFilter :visible="false" />
      <DxFilterRow :visible="true" />
      <DxLoadPanel :show-pane="false" />
      <DxSearchPanel :visible="true" placeholder="Cauta Produsul" :search-visible-columns-only="true" />
      <DxExport :enabled="true" :allow-export-selected-data="true" :formats="['xlsx', 'pdf']" />
      <DxColumnFixing :enabled="true" />
      <DxGridToolbar>
        <DxGridToolbarItem location="before" locate-in-menu="auto">
          <div>
            <dx-button icon="plus" width="30px" height="30px" @click="onAddClick" :disabled="isLocked"
              hint="Adaugă produs existent" />
          </div>
        </DxGridToolbarItem>
        <DxGridToolbarItem location="after" locate-in-menu="auto">
          <div>
            <dx-button icon="plus" width="30px" height="30px" type="success" hint="Adaugă produs nou"
              @click="onAddNewProdus" :disabled="isLocked" />

          </div>
        </DxGridToolbarItem>
        <DxGridToolbarItem location="after" locate-in-menu="auto">
          <div>
            <DxButton icon="refresh" width="30px" height="30px" @click="onRefreshClick" />
          </div>
        </DxGridToolbarItem>
        <DxGridToolbarItem location="after" locate-in-menu="auto">
          <div>
            <div class="separator"></div>
          </div>
        </DxGridToolbarItem>
        <DxGridToolbarItem name="exportButton" width="30px" height="30px" />
        <DxGridToolbarItem location="after" locate-in-menu="auto">
          <div>
            <div class="separator"></div>
          </div>
        </DxGridToolbarItem>
        <DxGridToolbarItem name="columnChooserButton" width="10px" height="10px" />
        <DxGridToolbarItem name="searchPanel" />
      </DxGridToolbar>
      <DxTexts group-continued-message="Continuat de pe pagina anterioara"
        group-continues-message="Continuat pe pagina urmatoare" />
      <DxEditing :allowUpdating="!isLocked" :allowDeleting="!isLocked" mode="row" new-row-position="last">
        <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="700" :height="430">
          <DxToolbarItem :template="customTitleTemplate" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
        </DxPopup>
        <DxFormGrid :col-span="4" :col-count="4">
          <DxFormItemGrid :col-span="4" :col-count="4" item-type="group">
            <DxFormItemGrid data-field="ProdusID" :label="{ text: 'Produs' }" :col-span="3" />

            <DxFormItem dataField="Cantitate" editorType="dxNumberBox"
              :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" :col-span="1" />

            <DxFormItemGrid data-field="PretListaValutaID" :label="{ text: 'Valută' }" />
            <DxFormItem dataField="Pret" editorType="dxNumberBox"
              :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" />
            <DxFormItem dataField="DiscountProc" editorType="dxNumberBox" :label="{ text: 'Discount' }"
              :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" />
            <DxFormItem dataField="PretSpecial" editorType="dxNumberBox"
              :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" />
            <DxFormItem dataField="Observatii" :col-span="4" :editor-options="{ width: '100%', height: '100px' }"
              editorType="dxTextArea" />

          </DxFormItemGrid>

        </DxFormGrid>

      </DxEditing>

      <DxStateStoring :enabled="true" :filterValue="false" storage-key="CrmSalesProducts" />
      <DxColumn data-field="ProdusID" :edit-cell-template="'produsCellEditor'" caption="Articol"
        :calculate-display-value="calculateProductDisplayValue" :fixed="true" fixed-position="left" />
      <DxColumn data-field="Produs.Cod" caption="Cod Produs" :allowEditing="false" fixed-position="left" />
      <DxColumn data-field="Produs.Nume" caption="Nume Produs" :allowEditing="false" fixed-position="left" />
      <template #produsCellEditor="{ data }">
        <DxDropDownBox :data-source="dsProduse" value-expr="Id" :display-expr="displayProdus" :value="data.value"
          v-model:opened="isProdusDdbOpen" :show-clear-button="true" content-template="produsGridContent"
          placeholder="Selectează produs..." width="1200px">
          <template #produsGridContent>
            <DxDataGrid :data-source="dsProduse" key-expr="Id" height="100%" width="1500px"
              @selection-changed="(e) => onProdusSelectionChanged(e, data)">

              <DxSelection mode="single" />

              <DxFilterRow :visible="true" />
              <DxColumn data-field="Cod" caption="Cod" width="120" />
              <DxColumn data-field="Nume" />
            </DxDataGrid>

          </template>
        </DxDropDownBox>
      </template>

      <DxColumn data-field="Sale.Titlu" caption="Oportunitate" :visible="false" />
      <DxColumn data-field="SaleID" :visible="false" :edit-cell-template="'saleCellEditor'" />
      <template #saleCellEditor="{ data }">
        <DxDropDownBox :data-source="dsSales" value-expr="ID" :display-expr="display" :value="data.value"
          v-model:opened="isSaleDdbOpen" :show-clear-button="true" content-template="saleGridContent">
          <template #saleGridContent>
            <DxDataGrid :data-source="dsSales" key-expr="ID" :columns="['Titlu']" height="100%" @selection-changed="e => {
              const id = e.selectedRowKeys?.[0] ?? null;
              data.setValue(id);
              isSaleDdbOpen = false;
            }">
              <DxSelection mode="single" />
            </DxDataGrid>
          </template>
        </DxDropDownBox>
      </template>
      <DxColumn data-field="Cantitate">
        <DxRequiredRule message="Cantitatea este obligatorie" />
      </DxColumn>
      <DxColumn data-field="Pret" :set-cell-value="setPretValue" :format="'#,##0.00 '">
        <DxRequiredRule message="Pretul este obligatoriu" />
      </DxColumn>
      <DxColumn data-field="DiscountProc" :set-cell-value="setDiscountValue" caption="Discount %" />
      <DxColumn data-field="PretSpecial" :set-cell-value="setPretSpecialValue" caption="Preț Special"
        :format="'#,##0.00 '" />
      <DxColumn data-field="PretListaValutaID" :edit-cell-template="'pretListaValutaCellEditor'" caption="Valută"
        :calculate-display-value="calculateValutaDisplayValue" />
      <template #pretListaValutaCellEditor="{ data }">
        <DxDropDownBox :data-source="dsPretListaValuta" value-expr="Id" :display-expr="displayValuta"
          :value="data.value" v-model:opened="isValutaDdbOpen" :show-clear-button="true"
          content-template="pretValutaGridContent" placeholder="RON">
          <template #pretValutaGridContent>
            <DxDataGrid :data-source="dsPretListaValuta" key-expr="Id" :columns="['Simbol']" height="100%"
              @selection-changed="e => {
                const id = e.selectedRowKeys?.[0] ?? null;
                data.setValue(id);
                isValutaDdbOpen = false;
              }">
              <DxSelection mode="single" />
            </DxDataGrid>
          </template>
        </DxDropDownBox>
      </template>
      <DxColumn data-field="ValoareTotala" caption="Valoare Totală (RON)" :calculate-cell-value="calculateTotalValue"
        :format="'#,##0.00 '" :allow-editing="false" />
      <DxColumn type="buttons" :buttons="[
        {
          hint: 'Vezi detalii',
          icon: 'info',
          onClick: onViewDetails
        },
        {
          name: 'edit',
          visible: !isLocked
        },
        {
          name: 'delete',
          visible: !isLocked
        }
      ]" />

      <DxSummary>
        <DxTotalItem column="Cantitate" summary-type="sum" display-format="Total: {0}" />
        <DxTotalItem column="ValoareTotala" summary-type="sum" :value-format="'#,##0.00 '"
          display-format="Total: {0} RON" />
      </DxSummary>
    </DxDataGrid>
    <DxPopupAdd v-model:visible="isProductsDetailsVisible" :drag-enabled="false" :hide-on-outside-click="true"
      :show-close-button="true" :width="750" :height="600">
      <template #title>
        <div class="popup-header popup-header--products">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-product"></span>
            <div class="popup-header-texts">

              <div class="popup-header-subtitle">Componente Oportunitate CRM</div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span class="status-chip status-chip--active">
              {{ selectedProduct.Disponibilitate || 'Activ' }}
            </span>
          </div>
        </div>
      </template>

      <DxScrollView width="100%" height="100%" class="details-scroll-view">
        <div class="details-container">
          <!-- Quick Stats Row -->
          <div class="stats-grid">
            <div class="stat-card stat-card--quantity">
              <div class="stat-icon dx-icon-box"></div>
              <div class="stat-content">
                <div class="stat-label">Cantitate</div>
                <div class="stat-value">{{ selectedProduct.Cantitate || 0 }} buc</div>
              </div>
            </div>
            <div class="stat-card stat-card--price">
              <div class="stat-icon dx-icon-money"></div>
              <div class="stat-content">
                <div class="stat-label">Preț </div>
                <div class="stat-value">{{ selectedProduct.Pret }}
                </div>
              </div>
            </div>

          </div>

          <!-- Main Info Grid -->
          <div class="info-sections-grid">
            <!-- Left Column: Product Info -->
            <div class="info-column">
              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-info section-icon"></span>
                  <span>Informații Articol</span>
                </div>
                <div class="info-list">
                  <div class="info-item">
                    <label>Nume Produs</label>
                    <div class="value highlight">{{ selectedProduct.Produs?.Nume || selectedProduct.ProdusNume || '-' }}
                    </div>
                  </div>
                  <div class="info-item">
                    <label>Cod Produs</label>
                    <div class="value">{{ selectedProduct.Produs?.Cod || selectedProduct.ProdusCod || '-' }}</div>
                  </div>
                  <div class="info-item">
                    <label>Preț</label>
                    <div class="value">
                      {{ selectedProduct.Pret || '-' }}
                    </div>
                  </div>

                </div>
              </div>


            </div>

            <!-- Right Column: Commercial & Stock -->
            <div class="info-column">
              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-cart section-icon"></span>
                  <span>Date Comerciale</span>
                </div>
                <div class="info-list">
                  <div class="info-item">
                    <label>Valuta</label>
                    <div class="value">{{ calculateValutaDisplayValue(selectedProduct) }}</div>
                  </div>
                  <div class="info-item">
                    <label>Preț Special </label>
                    <div class="value success">
                      {{ selectedProduct.PretSpecial }}
                    </div>
                  </div>
                  <div class="info-item">
                    <label>Discount (%)</label>
                    <div class="value highlight">-{{ selectedProduct.DiscountProc || 0 }}%</div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- Bottom Meta Section -->
          <div class="system-meta-card">
            <div class="meta-row">
              <div class="meta-item">
                <span class="dx-icon-user meta-icon"></span>
                <span>Creat la {{ formatDate(selectedProduct.DataCreare, true) }}</span>
              </div>
              <div class="meta-separator"></div>
              <div class="meta-item">
                <span class="dx-icon-edit meta-icon"></span>
                <span>Modificat la {{ formatDate(selectedProduct.DataModificare, true) }}</span>
              </div>
            </div>
          </div>
        </div>
      </DxScrollView>
    </DxPopupAdd>
    <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false" :showTitle="true"
      :width="750" :height="480">
      <template #title>
        <div class="popup-header">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-add"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">Adăugare produs</div>
              <div class="popup-header-subtitle">
                Completează informațiile în pașii de mai jos
              </div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span class="status-chip status-chip--draft">
              Nouă
            </span>
          </div>
        </div>
      </template>
      <div ref="popupBody" class="popup-body-simple popup-body-modern">
        <div class="form-content form-content-modern">
          <DxForm :formData="formData" :col-span="4" :col-count="4" @field-data-changed="onFieldDataChanged">


            <DxFormItem :label="{ text: 'Produs' }" :col-span="3">

              <DxRequiredRule message="Câmpul 'Produs' este obligatoriu" />
              <DxDropDownBox v-model:value="sProdus" :data-source="dsProduse" value-expr="Id"
                :display-expr="displayProdus" :show-clear-button="true" placeholder="Selectează produs"
                content-template="produsAddPopupContent">

                <template #produsAddPopupContent>
                  <div class="dropdown-grid-container" style="height: 350px;">
                    <DxDataGrid :data-source="dsProduse" :hover-state-enabled="true" :height="280"
                      :remote-operations="true" @row-click="onProdusRowClick">
                      <DxColumn data-field="Nume" caption="Denumire produs" />
                      <DxColumn data-field="Cod" caption="Cod produs" width="150" />


                      <DxPaging :enabled="true" :page-size="5" />
                      <DxFilterRow :visible="true" />
                      <DxScrolling mode="virtual" />

                      <DxGridToolbar>
                        <DxGridToolbarItem location="after">
                          <DxButton icon="plus" type="success" height="25px" width="25px" @click="onAddNewProdus" />
                        </DxGridToolbarItem>
                        <DxGridToolbarItem name="searchPanel" />
                      </DxGridToolbar>
                    </DxDataGrid>

                  </div>
                </template>
              </DxDropDownBox>
            </DxFormItem>

            <!-- <DxFormItem dataField="ProdusCod" :label="{ text: 'Cod Produs' }" :editor-options="{ readOnly: true }" />
            <DxFormItem dataField="ProdusNume" :label="{ text: 'Nume Produs' }" :col-span="2"
              :editor-options="{ readOnly: true }" /> -->

            <DxFormItem dataField="Cantitate" editorType="dxNumberBox"
              :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }">
              <DxRequiredRule message="Câmpul 'Cantitate' este obligatoriu" />
            </DxFormItem>


            <DxFormItem dataField="Pret" editorType="dxNumberBox"
              :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }">
              <DxRequiredRule message="Câmpul 'Pret' este obligatoriu" />
            </DxFormItem>
            <DxFormItem dataField="DiscountProc" editorType="dxNumberBox"
              :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" />
            <DxFormItem dataField="PretSpecial" editorType="dxNumberBox"
              :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" />
            <DxFormItem :label="{ text: 'Valută' }">
              <DxDropDownBox v-model:value="sValute" :data-source="dsPretListaValuta" display-expr="Simbol"
                value-expr="Id" :show-clear-button="true" content-template="valutaAddPopupContent">
                <template #valutaAddPopupContent>
                  <div class="dropdown-grid-container" style="height: 300px;">
                    <DxDataGrid :data-source="dsPretListaValuta" :columns="['Simbol']" :hover-state-enabled="true"
                      :height="280" :remote-operations="true" @row-click="onValuteRowClick">
                      <DxPaging :enabled="true" :page-size="5" />
                      <DxFilterRow :visible="true" />
                      <DxScrolling mode="virtual" />
                    </DxDataGrid>
                  </div>
                </template>
              </DxDropDownBox>
            </DxFormItem>
            <DxFormItem dataField="Observatii" :col-span="4" :editor-options="{ width: '100%', height: '100px' }"
              editorType="dxTextArea" />


            <!-- <DxFormItem item-type="group" caption="Detalii Financiare" :col-count="2">
              <DxFormItem dataField="PretSpecial" editorType="dxNumberBox"
                :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" />
              <DxFormItem dataField="PretVanzare" editorType="dxNumberBox"
                :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" />
              <DxFormItem dataField="DiscountProc" editorType="dxNumberBox"
                :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" />
              <DxFormItem dataField="TVA" editorType="dxNumberBox"
                :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" />
              <DxFormItemGrid :label="{ text: 'Valuta' }">
                <DxDropDownBox v-model:opened="isValuteGridBoxOpened" :data-source="valutaSelectat"
                  v-model:value="sValuta" :show-clear-button="true" display-expr="Simbol" value-expr="Id">

                  <template #valutaLegacyContent="{ data }">
                    <DxDataGrid :data-source="dsValuta" v-model:value="sValuta" :columns="['Simbol']"
                      :hover-state-enabled="true" height="100%" @selection-changed="onValueSelectedValuta($event)">
                      <DxSelection mode="single" />
                      <DxPaging :enabled="true" :page-size="5" />
                      <DxFilterRow :visible="true" />
                      <DxSearchPanel :visible="true" placeholder="Cauta ..." />
                    </DxDataGrid>
                  </template>
                </DxDropDownBox>
              </DxFormItemGrid>
              <DxFormItem dataField="PretListaCurs" editorType="dxNumberBox"
                :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" />
              <DxFormItem dataField="CostAcSpec" editorType="dxNumberBox"
                :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" />
            </DxFormItem> -->


            <!-- <DxFormItem item-type="group" caption="Clasificare" :col-count="2">

             

              <DxFormItem dataField="Grupare" :editor-options="{ width: '100%' }" />
             
            </DxFormItem>


            <DxFormItem item-type="group" caption="Furnizor & Stoc" :col-count="2">
              <DxFormItem :label="{ text: 'Furnizor' }" :col-span="2">
                <DxDropDownBox v-model:opened="isFurnizorGridBoxOpened" :data-source="furnizorSelectat"
                  v-model:value="sFurnizor" :show-clear-button="true" display-expr="Nume" value-expr="ID">
                  <template #furnizorContent="{ data }">
                    <DxDataGrid :data-source="dsFurnizori" v-model:value="sFurnizor" :columns="['Nume']"
                      :hover-state-enabled="true" height="100%" @selection-changed="onValueSelectedFurnizor($event)">
                      <DxSelection mode="single" />
                      <DxPaging :enabled="true" :page-size="5" />
                      <DxFilterRow :visible="true" />
                      <DxSearchPanel :visible="true" placeholder="Cauta ..." />
                    </DxDataGrid>
                  </template>
                </DxDropDownBox>
              </DxFormItem>
              <DxFormItem data-field="PretFurnizorID" :label="{ text: 'Pret Furnizor' }" editor-type="dxDropDownBox"
                :editor-options="{
                  dataSource: dsFurnizoriPret,
                  valueExpr: 'ID',
                  displayExpr: display,
                  contentTemplate: 'content',
                  showClearButton: true
                }" />
              <DxFormItem dataField="Disponibilitate" :editor-options="{ width: '100%' }" />
              <DxFormItem dataField="DisponibilitateZile" :editor-options="{ width: '100%' }" />
              <DxFormItem dataField="CantitateStoc" editorType="dxNumberBox"
                :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" />
              <DxFormItem dataField="FurnizorPret" editorType="dxNumberBox"
                :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" />
              <DxFormItem dataField="FurnizorPretCurs" editorType="dxNumberBox"
                :editor-options="{ format: '#0.00', showSpinButtons: true, width: '100%' }" />
            </DxFormItem>


            <DxFormItem item-type="group" caption="Altele" :col-count="2">
              <DxFormItem dataField="NrCrt" :editor-options="{ width: '100%' }" />
              <DxFormItem dataField="IsProdusIdERA" editorType="dxCheckBox" />
              <DxFormItem dataField="ProdusCod" :editor-options="{ width: '100%' }" />
              <DxFormItem dataField="ProdusNume" :editor-options="{ width: '100%' }" />
            </DxFormItem> -->

          </DxForm>
        </div>
        <div class="form-footer footer-fixed footer-modern">
          <div class="footer-right">
            <DxButton text="Salvează" type="success" width="120" height="32" styling-mode="outlined" @click="onSaveAdd"
              :disabled="isLocked" />
            <DxButton text="Închide" type="danger" width="120" height="32" styling-mode="outlined" @click="onCancel" />
          </div>
        </div>
      </div>
    </DxPopupAdd>

    <DxPopupAdd :visible="isProdusModalVisible" :width="750" :height="480" :show-title="true" title="Adăugare Produs"
      @hiding="isProdusModalVisible = false">
      <template #title>
        <div class="popup-header">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-add"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">Adăugare produs nou</div>
              <div class="popup-header-subtitle">
                Completează detaliile produsului
              </div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span class="status-chip status-chip--draft">
              Nou
            </span>
          </div>
        </div>
      </template>
      <div class="popup-body-modern">
        <DxForm :form-data="newProductData" :col-count="2" :col-span="2"
          @field-data-changed="onNewProductFieldDataChanged">


          <DxFormItem data-field="Cod" :label="{ text: 'Cod Produs' }" :col-span="2" :col-count="2">
            <DxRequiredRule message="Codul produsului este obligatoriu" />
          </DxFormItem>
          <DxFormItem data-field="Nume" :label="{ text: 'Descriere Produs' }" :col-span="2" :col-count="2"
            :editor-options="{ height: 80 }" editor-type="dxTextArea">
            <DxRequiredRule message="Descrierea produsului este obligatorie" />
          </DxFormItem>


          <DxFormItem data-field="Stocabil" editor-type="dxCheckBox" :label="{ text: 'Produs' }" />
          <DxFormItem data-field="Serviciu" editor-type="dxCheckBox" />


        </DxForm>
        <div class="form-footer footer-fixed footer-modern">
          <div class="footer-right" style="margin-top: 20px; text-align: right;">
            <DxButton text="Salvează" type="success" @click="onSaveNewProduct" height="32px" width="200px"
              styling-mode="outlined" :disabled="isLocked" />
            <DxButton text="Închide" @click="isProdusModalVisible = false" height="32px" width="200px"
              styling-mode="outlined" />
          </div>
        </div>
      </div>
    </DxPopupAdd>
  </div>
</template>
<script lang="ts">
import { locale, loadMessages } from 'devextreme/localization';
import DxDropDownButton, { DxDropDownButtonTypes } from 'devextreme-vue/drop-down-button';
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd from 'devextreme-vue/popup';
import { DxSimpleItem, DxLabel } from 'devextreme-vue/form';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxForm, DxItem as DxFormItem } from 'devextreme-vue/form';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridExcel } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import CrmSalesProducts from '@/services/Comercial/CrmSalesProducts';
import DataSource from "devextreme/data/data_source";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import PAR_Parteneri from "@/services/PAR/PAR_Parteneri";
import PRO_Produse from "@/services/PRO/Produse";
import { DxRequiredRule } from 'devextreme-vue/form';
import {
  DxItem as DxGridToolbarItem,
  DxLookup,
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar as DxGridToolbar,
  DxEditing,
  DxColumnChooser,
  DxGrouping,
  DxGroupPanel,
  DxTexts,
  DxExport,
  DxSearchPanel,
  DxMasterDetail,
  DxPopup,
  DxToolbarItem,
  DxForm as DxFormGrid,
  DxItem as DxFormItemGrid,
  DxScrolling,
  DxHeaderFilter,
  DxSummary,
  DxTotalItem,
  DxColumnFixing
} from 'devextreme-vue/data-grid';

export default defineComponent({
  components: {
    DxGridToolbar,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxLoadPanel,
    DxPaging,
    DxButton,
    DxEditing,
    DxPopupAdd,
    DxForm,
    DxSimpleItem,
    DxLabel,
    DxScrollView,
    DxLookup,
    DxColumnChooser,
    DxGrouping,
    DxGroupPanel,
    DxTexts,
    DxExport,
    DxSearchPanel,
    DxMasterDetail,
    DxPopup,
    DxToolbarItem,
    DxFormGrid,
    DxGridToolbarItem,
    DxScrolling,
    DxHeaderFilter,
    DxDropDownButton,
    DxFormItem,
    DxDropDownBox,
    DxFormItemGrid,

    DxRequiredRule,
    DxSummary,
    DxTotalItem,
    DxColumnFixing
  },
  props: {
    opportunityId: {
      type: String,
      required: true
    },
    opportunityData: {
      type: Object,
      required: true
    },
    isLocked: {
      type: Boolean,
      default: false
    },
    offerId: {
      type: String,
      required: false
    },
    autoAdd: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isValuteGridBoxOpened: false,
      isTipActivitateGridBoxOpened: false,
      isProdusGridBoxOpened: false,
      sProdus: null,
      isProdusModalVisible: false,
      newProductData: {
        Ordine: null,
        PartenerID: null,
        Cod: '',
        Nume: '',
        PretListaValutaID: null,
        CodIBAN: '',
        CodBIC: '',
        CodSWIFT: '',
        TextFC: '',
        Principala: false,
        Activ: true,
        Stocabil: true,
        Serviciu: false,
      },
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
      claseOptions: [],

      sValute: null,
      isClasaGridBoxOpened: false,
      sClasa: null,
      produsSelectat: [],

      isCategorieGridBoxOpened: false,
      sCategorie: null,
      categorieSelectat: [],


      sValuta: null,
      valutaSelectat: [],
      isFurnizorGridBoxOpened: false,
      sFurnizor: null,
      furnizorSelectat: [],
      ofertaSelectat: [],

      dsValuta: {} as ODataStore,
      isOportunitateGridBoxOpened: false,
      sOportunitate: null,
      oportunitateSelectat: [],
      dsSales: {} as ODataStore,
      dsSalesProducts: {} as ODataStore,

      dsClase: {} as DataSource,
      dsProduse: {} as ODataStore,
      dsCategorii: {} as ODataStore,
      dsFurnizori: {} as ODataStore,
      dsFurnizoriPret: {} as ODataStore,
      dsLucrari: {} as ODataStore,
      dsPretListaValuta: {} as ODataStore,
      dsOferte: {} as ODataStore,
      dsValute: {} as DataSource,
      isModalVisible: false,
      isProductsDetailsVisible: false,
      selectedProduct: {} as any,
      isPanelOpened: ref(false),
      dataGrid: ref<DxDataGrid | null>(null),
      isDdbOpen: false as boolean,
      isClaseDdbOpen: false as boolean,
      isProdusDdbOpen: false as boolean,
      isSaleDdbOpen: false as boolean,
      isCategoriiDdbOpen: false as boolean,
      isValutaDdbOpen: false as boolean,

      formData: {
        Produs: '',
        Sale: '',
        SaleID: null,
        ProdusID: null,
        Cantitate: null,
        Pret: null,
        Observatii: '',
        PretSpecial: null,
        Disponibilitate: null,
        Grupare: '',
        PretVanzare: null,
        CostAcSpec: null,
        ClasaID: null,
        CategorieID: null,
        TVA: null,
        FurnizorID: null,
        FurnizorPret: null,
        FurnizorPretValutaID: null,
        DisponibilitateZile: '',
        FurnizorPretCurs: null,
        NrCrt: '',
        DiscountProc: null,
        IsProdusIdERA: null,
        CantitateStoc: null,
        ProdusFurnizorID: null,
        ProdusCod: '',
        ProdusNume: '',
        LucrareID: '',
        PretListaValutaID: '',
        PretListaCurs: '',
        DataCreare: null,
        UserCreare: '',
        DataModificare: null,
        UserModificare: '',
        OfertaID: null
      },
      eurRate: 1,
      successButtonOptions: {
        type: 'success',
        stylingMode: 'outlined',
        text: 'Salvează',
        width: 120,
        height: 32,
        onClick: () => {
          this.SaveEdit();
        },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'outlined',
        text: 'Închide',
        width: 120,
        height: 32,
        onClick: () => {
          this.onCancel();
        },
      },
      customTitleTemplate() {
        return `
          <div class="popup-header" style="width: 720px; margin: -5px -20px 0 -20px; padding: 16px 24px; background: linear-gradient(90deg, #ff2c21, #ff6a4a); display: flex; align-items: center; gap: 16px;">
             <span class="dx-icon-edit" style="font-size: 24px;  width: 40px; height: 20px; display: flex; align-items: center; justify-content: center; border-radius: 8px; color: white;"></span>
             <div style="display: flex; flex-direction: column; color: white;">
                <span style="font-size: 16px; font-weight: 700;">Editare Produs existent</span>
                <span style="font-size: 12px; opacity: 0.9;">Modifică detaliile produsului selectat</span>
             </div>
          </div>
        `;
      },
    };
  },

  watch: {
    sOportunitate(newId) {
      if (newId) {
        this.dsSales.store().byKey(newId).then(x => {
          if (!x) return;
          x.Titlu = (x.Titlu ?? '(fara nume)');
          this.oportunitateSelectat = [x];
        });

      } else {
        this.oportunitateSelectat = [];
      }
    },
    offerId(newId) {
      if (newId) {
        this.dsOferte.store().byKey(newId).then(x => {
          if (!x) return;
          x.Nume = (x.Nume ?? '(fara nume)');
          this.ofertaSelectat = [x];
        });

      } else {
        this.ofertaSelectat = [];
      }
    },
    sPartener(newId) {
      if (newId) {
        this.dsParteneri.store().byKey(newId).then(x => {
          if (!x) return;
          x.Nume = (x.Nume ?? '(fara nume)');
          this.partenerSelectat = [x];
        });
      } else {
        this.partenerSelectat = [];
      }
    },

    sValuta(newId) {
      if (newId) {
        this.dsPretListaValuta.store().byKey(newId).then(x => {
          if (!x) return;
          x.Simbol = (x.Simbol ?? '(fara nume)');
          this.valutaSelectat = [x];
        });

      } else {
        this.valutaSelectat = [];
      }
    },
    sProdus(newId) {
      if (newId) {
        this.dsProduse.store().byKey(newId).then(x => {
          if (!x) return;
          x.Nume = (x.Nume ?? '(fara nume)');
          this.produsSelectat = [x];
        });
      } else {
        this.produsSelectat = [];
      }
    },
  },
  methods: {
    calculateTotalValue(rowData) {
      const cantitate = rowData.Cantitate || 0;
      // Use PretSpecial if DiscountProc is non-zero (even if 0 for 100% discount or negative for surcharge)
      const pret = (rowData.DiscountProc !== 0 && rowData.DiscountProc !== null && rowData.DiscountProc !== undefined)
        ? (rowData.PretSpecial ?? 0)
        : (rowData.Pret || 0);

      let total = cantitate * pret;

      // Convert to RON if currency is EUR
      const valuta = this.calculateValutaDisplayValue(rowData);
      if (valuta === 'EUR') {
        total = total * this.eurRate;
      }

      return total;
    },
    onValuteRowClick(e) {
      this.isValuteGridBoxOpened = false;

      if (e.data) {
        this.sValute = e.data.Id;
        this.sValuta = e.data.Id;
        this.formData.PretListaValutaID = e.data.Id;
      } else {
        this.sValute = null;
        this.sValuta = null;
        this.formData.PretListaValutaID = null;
      }
    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGrid?.instance;
      dataGrid.option('editing', {
        allowDeleting: !this.isLocked,
        mode: 'row',
        newRowPosition: 'last',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        }
      });
    },
    createODataContext() {
      this.dsValute = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
          key: 'Id',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };

          }
        },
        select: [
          'Id',
          'Simbol',
        ],

      });
      this.dsSalesProducts = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'CRM_SalesProducts',
        key: 'ID',
        keyType: "Guid",
        fieldTypes: {
          SaleID: 'Guid',
          ProdusID: 'Guid',
          ClasaID: 'Guid',
          CategorieID: 'Guid',
          FurnizorID: 'Guid',
          OfertaID: 'Guid'
        },
        version: 4,
        beforeSend: (e) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
          };

          e.params.$expand = "Sale($select=Titlu),Produs($select=Nume,Cod),PretListaValuta($select=Simbol), Clasa($select=Nume)";

        }
      });
      this.dsSales = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'CRM_Sales',
          key: 'ID',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Titlu',
        ],

      });

      this.dsOferte = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'CRM_Oferte',
          key: 'ID',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Nume',
        ],

      });

      this.dsClase = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'PRO_Clase',
          key: 'ID',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Nume',
        ],

      });
      this.dsProduse = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'PRO_Produse',
          key: 'Id',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'Id',
          'Nume',
          'Cod',
          'Pret',

        ],

      });

      this.dsPretListaValuta = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
          key: 'Id',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'Id',
          'Simbol',
        ],

      });

      this.dsCategorii = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'PRO_Categorii',
          key: 'Id',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Nume',
        ],

      });

      this.dsFurnizori = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri',
          key: 'ID',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Nume',
        ],

      });
    },
    display(item) {
      return item ? (item.Nume || '(fără nume)') : '';
    },
    displayTitlu(item) {
      return item ? (item.Titlu || '(fără titlu)') : '';
    },
    displayClase(item) {
      return item ? (item.Nume || '(fără nume)') : '';
    },
    displayValuta(item) {
      return item ? (item.Simbol || '(fără nume)') : '';
    },


    toNullIfEmpty(val) {
      return val === '' || val === undefined || val === null ? null : val;
    },

    onValueSelectedProdus(e) {
      this.isProdusGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sProdus = e.selectedRowKeys[0];

      } else {
        this.sProdus = null;
      }
      this.formData.ProdusID = this.sProdus;
    },
    onProdusRowClick(e) {
      // 1. Close the dropdown
      this.isProdusGridBoxOpened = false;

      // 2. Update the value
      if (e.data) {
        this.sProdus = e.data.Id;
        this.formData.ProdusID = e.data.Id;
        this.formData.ProdusNume = e.data.Nume;
        this.formData.ProdusCod = e.data.Cod;

        // Optional: Pre-fill other fields if available in product data
        if (e.data.Pret !== undefined && e.data.Pret !== null) {
          this.formData.Pret = e.data.Pret;
          // Trigger calculations for discount/special price
          this.handleProductCalculations(this.formData, 'Pret');
        }

        if (e.data.PretListaValutaID) {
          this.formData.PretListaValutaID = e.data.PretListaValutaID;
          this.sValute = e.data.PretListaValutaID;
        }

        if (e.data.TVA !== undefined && e.data.TVA !== null) {
          this.formData.TVA = e.data.TVA;
        }
      } else {
        this.sProdus = null;
        this.formData.ProdusID = null;
        // Resetting to defaults
      }
    },
    onAddNewProdus() {
      this.isProdusModalVisible = true;
      this.newProductData.Stocabil = true;
    },
    onSaveNewProduct() {
      if (!this.newProductData.Cod || this.newProductData.Cod.trim() === '') {
        notify('Completați câmpul obligatoriu "Cod Produs"!', 'error', 1000);
        return;
      }

      if (!this.newProductData.Nume || this.newProductData.Nume.trim() === '') {
        notify('Completați câmpul obligatoriu "Descriere Produs"!', 'error', 1000);
        return;
      }

      const body = { ...this.newProductData };
      // Map ClasaID if selected
      if (this.sClasa) {
        body.ClasaID = this.sClasa;
      }

      // Default values for required fields if needed
      if (!body.UnitateId) body.UnitateId = '31FD11E4-19B7-46E0-BBD5-204595349595'; // Default UM (Bucati mentioned in other code, confirming ID would be safer but using what was in data())

      PRO_Produse.save(body).then((response) => {
        this.isProdusModalVisible = false;
        notify('Produsul a fost salvat cu succes!', 'success', 1000);

        // API might return the created object or just success
        // Assuming response.data contains the created object or ID
        const newId = response?.data?.Id || response?.data?.ID || response?.data?.id;

        // Refresh data source and set selection
        this.dsProduse.reload().then(() => {
          if (newId) {
            this.sProdus = newId;
            this.formData.ProdusID = newId;
            this.formData.ProdusNume = body.Nume;
            if (body.Cod) this.formData.ProdusCod = body.Cod;
          }
        });

        // Reset form data
        this.newProductData = {
          CategorieId: null,
          ClasaId: null,
          Serviciu: false,
          Stocabil: true,
          UnitateId: '31FD11E4-19B7-46E0-BBD5-204595349595',
          Pret: '',
          PretVanzare: '',
          Imagine: null,
          Nume: '',
          Cod: '',
          CodIntern: ''
        };
        this.sClasa = null;

      }).catch((error) => {
        console.error(error);
        notify('Eroare la salvare produs! Verificați dacă codul sau numele există deja.', 'error', 2000);
      });
    },

    onValueSelectedClasa(e) {
      this.isClasaGridBoxOpened = false;
      this.sClasa = e.selectedRowKeys?.[0] ?? null;
      this.formData.ClasaID = this.sClasa;
    }
    ,

    onValueSelectedCategorie(e) {
      this.isCategorieGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sCategorie = e.selectedRowKeys[0];

      } else {
        this.sCategorie = null;
      }
      this.formData.CategorieID = this.sCategorie;
    },
    onValueSelectedFurnizor(e) {
      this.isFurnizorGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sFurnizor = e.selectedRowKeys[0];

      } else {
        this.sFurnizor = null;
      }
      this.formData.FurnizorID = this.sFurnizor;
    },

    normalizeFormData(formData) {
      const cleaned = { ...formData };
      const dateFields = [
        'Data',
        'DataCreat',
      ];

      dateFields.forEach((field) => {
        const val = cleaned[field];
        cleaned[field] = this.toNullIfEmpty(val) !== null ? new Date(val) : null;
      });

      Object.keys(cleaned).forEach((key) => {
        cleaned[key] = this.toNullIfEmpty(cleaned[key]);
      });

      return cleaned;
    },
    displayProdus(item) {
      if (!item) return '';
      return `${item.Cod} - ${item.Nume}`;
    },
    onSaveAdd() {

      if (!this.formData.ProdusID) {
        notify('Completați câmpul obligatoriu "Produs"!', 'error', 1000);
        return;
      }

      if (!this.formData.Cantitate) {
        notify('Completați câmpul obligatoriu "Cantitate"!', 'error', 1000);
        return;
      }

      if (!this.formData.Pret) {
        notify('Completați câmpul obligatoriu "Pret"!', 'error', 1000);
        return;
      }

      const cleanedFormData = this.normalizeFormData(this.formData);
      const backendFields = [
        'SaleID', 'ProdusID', 'Cantitate', 'Pret', 'Observatii', 'PretSpecial',
        'Disponibilitate', 'Grupare', 'PretVanzare', 'CostAcSpec', 'ClasaID',
        'CategorieID', 'TVA', 'FurnizorID', 'FurnizorPret', 'FurnizorPretValutaID',
        'DisponibilitateZile', 'FurnizorPretCurs', 'NrCrt', 'DiscountProc',
        'IsProdusIdERA', 'CantitateStoc', 'ProdusFurnizorID', 'ProdusCod',
        'ProdusNume', 'LucrareID', 'PretListaValutaID', 'PretListaCurs', 'OfertaID'
      ];

      const payload = Object.fromEntries(
        Object.entries(cleanedFormData).filter(([key]) =>
          backendFields.includes(key)
        )
      );

      payload.OfertaID = this.toNullIfEmpty(this.offerId);
      payload.SaleID = this.toNullIfEmpty(this.opportunityId);
      if (this.sProdus) payload.ProdusID = this.sProdus;

      CrmSalesProducts.save(payload)
        .then(() => {
          this.isModalVisible = false;
          notify('Datele au fost salvate cu succes!', 'success', 1000);
          this.formData = {
            Produs: '',
            Sale: '',
            SaleID: null,
            ProdusID: null,
            Cantitate: null,
            Pret: null,
            Observatii: '',
            PretSpecial: null,
            Disponibilitate: null,
            Grupare: '',
            PretVanzare: null,
            CostAcSpec: null,
            ClasaID: null,
            CategorieID: null,
            TVA: null,
            FurnizorID: null,
            FurnizorPret: null,
            FurnizorPretValutaID: null,
            DisponibilitateZile: '',
            FurnizorPretCurs: null,
            NrCrt: '',
            DiscountProc: null,
            IsProdusIdERA: null,
            CantitateStoc: null,
            ProdusFurnizorID: null,
            ProdusCod: '',
            ProdusNume: '',
            LucrareID: '',
            PretListaValutaID: null,
            PretListaCurs: '',
            DataCreare: null,
            UserCreare: '',
            DataModificare: null,
            UserModificare: ''
          };
          this.sOportunitate = null;
          this.sProdus = null;
          this.createODataContext();
        })
        .catch((error) => {
          notify('Eroare la salvare!', 'error', 1500);
        });
    },
    onClasaSelectionChanged(e) {
      const id = e.selectedRowKeys?.[0] ?? null;

      // guard anti-loop + select corect
      if (id !== this.sClasa) this.sClasa = id;

      this.isClasaGridBoxOpened = false;
    },
    onValueSelectedPartener(e) {

      this.isParteneriGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sPartener = e.selectedRowKeys[0];

      } else {
        this.sPartener = null;
      }
      this.formData.AccountID = this.sPartener;

    },
    onValueSelectedOportunitate(e) {
      this.isOportunitateGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sOportunitate = e.selectedRowKeys[0];

      } else {
        this.sOportunitate = null;
      }
      this.formData.SaleID = this.sOportunitate;

    },
    onValueSelectedTipActivitate(e) {
      this.isTipActivitateGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sTipActivitate = e.selectedRowKeys[0];

      } else {
        this.sTipActivitate = null;
      }
      this.formData.TipActivitateID = this.sTipActivitate;

    },
    onValueSelectedValuta(e) {
      this.isValuteGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sValuta = e.selectedRowKeys[0];

      } else {
        this.sValuta = null;
      }
      this.formData.PretListaValutaID = this.sValuta;
    },

    onViewDetails(e) {
      const rowData = e?.row?.data;
      if (rowData) {
        this.showProductsDetails(rowData);
      }
    },
    showProductsDetails(product: any) {
      this.selectedProduct = { ...product };
      this.isProductsDetailsVisible = true;
    },
    formatDate(dateStr: string, includeTime = false) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return '-';

      const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      };

      if (includeTime) {
        options.hour = '2-digit';
        options.minute = '2-digit';
      }

      return d.toLocaleDateString('ro-RO', options);
    },
    formatCurrency(value: number, currency?: string) {
      if (value === null || value === undefined) return '-';
      return new Intl.NumberFormat('ro-RO', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value) + ' ' + (currency || this.opportunityCurrencySymbol);
    },
    formatCurrencyPrice(value: number, currency: string = null) {
      if (value === null || value === undefined) return '-';

      const formattedNumber = new Intl.NumberFormat('ro-RO', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);

      return `${formattedNumber} ${currency || this.opportunityCurrencySymbol}`;
    },
    onAddClick() {
      this.$refs.dataGrid?.instance?.addRow();
    },
    onRefreshClick() {
      this.createODataContext();
      notify('Datele au fost actualizate cu succes!', 'success', 1000);
    },
    SaveEdit() {
      const savePromise = this.$refs.dataGrid?.instance?.saveEditData();
      savePromise
        .then(() => {
          notify('Datele au fost salvate cu succes!', 'success', 1000);
        })
        .catch((error) => {
          notify('Eroare la salvarea datelor!', 'error', 1000);
        });
    },
    onInitNewRow(e) {
      e.data.SaleID = this.opportunityId;
      e.data.OfertaID = this.offerId;
      e.data.Cantitate = 1;
      e.data.Pret = 0;
      e.data.PretListaValutaID = this.opportunityData?.ValutaID || '0A61647E-7391-4087-BC01-8EB9C2CEDEDD'; // Default to original RON if not provided
      e.data.DiscountProc = 0;
      e.data.PretSpecial = 0;
    },
    onRowInserted() {
      // Automatically open a new row after a successful save, only if not locked
      if (!this.isLocked) {
        this.onAddClick();
      }
    },
    onProdusSelectionChanged(e, data) {
      const row = e.selectedRowsData?.[0];
      const id = row?.Id ?? null;
      data.setValue(id);
      if (row) {
        // Update related fields in the editing row
        const grid = data.component;
        grid.cellValue(data.rowIndex, 'ProdusCod', row.Cod);
        grid.cellValue(data.rowIndex, 'ProdusNume', row.Nume);

        // Sync nested object fields for grid display
        grid.cellValue(data.rowIndex, 'Produs.Cod', row.Cod);
        grid.cellValue(data.rowIndex, 'Produs.Nume', row.Nume);

        // Also update price if it's 0 or null
        const currentPret = grid.cellValue(data.rowIndex, 'Pret');
        if (!currentPret && row.Pret) {
          grid.cellValue(data.rowIndex, 'Pret', row.Pret);
        }

        // Move focus to Cantitate column after a short delay to ensure value is set
        setTimeout(() => {
          grid.editCell(data.rowIndex, 'Cantitate');
        }, 50);
      }
      this.isProdusDdbOpen = false;
    },
    onCancel() {
      this.isModalVisible = false;
      this.$refs.dataGrid?.instance?.cancelEditData();
    },
    onRowRemoving() {
      notify('Datele au fost șterse cu succes!', 'success', 1000);
    },

    onExporting(e: any) {
      if (e.format === 'pdf') {
        const doc = new jsPDF();
        exportDataGridPdf({
          jsPDFDocument: doc,
          component: e.component,
          indent: 5,
        }).then(() => {
          doc.save('CrmActivitati.pdf');
        });
      } else if (e.format === 'xlsx') {

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('activitati');

        exportDataGridExcel({
          component: e.component,
          worksheet,
          autoFilterEnabled: true,
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer: any) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'CrmContacts.xlsx');
          });
        });
        e.cancel = true;
      }
    },
    async loadClase() {
      try {
        const resp = await fetch(`${AppSetting.API_Url_ComercialOdata}PRO_Clase`, {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
            Accept: 'application/json'
          }
        });
        if (!resp.ok) {
          console.error('Eroare la încărcare PRO_Clase', resp.status, await resp.text());
          return;
        }
        const json = await resp.json();
        const data = Array.isArray(json) ? json : (json.value ?? []);
        this.claseOptions = data;
      } catch (e) {
        console.error("Error loading classes: ", e);
      }
    },
    onFieldDataChanged(e) {
      this.handleProductCalculations(this.formData, e.dataField);
    },
    onNewProductFieldDataChanged(e) {
      if (e.dataField === 'Stocabil' && e.value === true) {
        this.newProductData.Serviciu = false;
      } else if (e.dataField === 'Serviciu' && e.value === true) {
        this.newProductData.Stocabil = false;
      }
    },
    setPretValue(newData, value, currentRowData) {
      newData.Pret = value;
      const pret = value || 0;
      const discount = (newData.DiscountProc !== undefined) ? newData.DiscountProc : (currentRowData.DiscountProc || 0);
      const pretSpecial = (newData.PretSpecial !== undefined) ? newData.PretSpecial : (currentRowData.PretSpecial || 0);

      if (discount > 0 || (pretSpecial > 0 && pret > 0 && discount === 0)) {
        // If there's a discount, keep it and update PretSpecial
        // Or if we have a PretSpecial and are at 0% discount, maybe user entered PretSpecial first?
        // But the most common case is keeping the discount.
        newData.PretSpecial = Math.round((pret * (1 - discount / 100)) * 100) / 100;

        // If discount was 0 but we had a pretSpecial, recalculate discount
        if (discount === 0 && pretSpecial > 0) {
          newData.DiscountProc = Math.round(((pret - pretSpecial) / pret) * 100 * 100) / 100;
        }
      } else {
        // Default: sync PretSpecial to Pret
        newData.PretSpecial = pret;
      }
    },
    setDiscountValue(newData, value, currentRowData) {
      newData.DiscountProc = value;
      const pret = (newData.Pret !== undefined) ? newData.Pret : (currentRowData.Pret || 0);
      const discount = value || 0;
      // Force calculation of PretSpecial whenever discount is changed
      newData.PretSpecial = Math.round((pret * (1 - discount / 100)) * 100) / 100;
    },
    setPretSpecialValue(newData, value, currentRowData) {
      newData.PretSpecial = value;
      const pret = (newData.Pret !== undefined) ? newData.Pret : (currentRowData.Pret || 0);
      const pretSpecial = value || 0;
      if (pret > 0) {
        newData.DiscountProc = Math.round(((pret - pretSpecial) / pret) * 100 * 100) / 100;
      }
    },
    handleProductCalculations(data, dataField) {
      if (dataField === 'Pret' || dataField === 'DiscountProc' || dataField === 'PretSpecial') {
        const pret = data.Pret || 0;
        const discount = data.DiscountProc || 0;
        const pretSpecial = data.PretSpecial || 0;

        if (dataField === 'Pret') {
          if (discount !== 0 || (pretSpecial > 0 && pret > 0)) {
            data.PretSpecial = Math.round((pret * (1 - discount / 100)) * 100) / 100;
            // If discount was 0 but we had pretSpecial, calculate discount
            if (discount === 0 && pretSpecial > 0) {
              data.DiscountProc = Math.round(((pret - pretSpecial) / pret) * 100 * 100) / 100;
            }
          } else {
            data.PretSpecial = pret;
          }
        } else if (dataField === 'DiscountProc') {
          data.PretSpecial = Math.round((pret * (1 - discount / 100)) * 100) / 100;
        } else if (dataField === 'PretSpecial') {
          if (pret > 0) {
            data.DiscountProc = Math.round(((pret - pretSpecial) / pret) * 100 * 100) / 100;
          }
        }
      }
    },
    calculateProductDisplayValue(rowData) {
      if (rowData.ProdusCod && rowData.ProdusNume) {
        return `${rowData.ProdusCod} - ${rowData.ProdusNume}`;
      }
      if (rowData.Produs && rowData.Produs.Cod) {
        return `${rowData.Produs.Cod} - ${rowData.Produs.Nume}`;
      }
      return rowData.ProdusID;
    },
    calculateValutaDisplayValue(rowData) {
      if (rowData.PretListaValuta && rowData.PretListaValuta.Simbol) {
        return rowData.PretListaValuta.Simbol;
      }
      return rowData.PretListaValutaID === '0A61647E-7391-4087-BC01-8EB9C2CEDEDD' ? 'RON' : rowData.PretListaValutaID;
    },
    async fetchEurRate() {
      try {
        const store = new ODataStore({
          url: AppSetting.API_Url_ComercialOdata + 'ERP_CursValutar',
          key: 'Id',
          version: 4,
          beforeSend: (e) => {
            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
            };
          }
        });

        const result = await store.load({
          filter: ["Simbol", "=", "EUR"],
          sort: [{ selector: "Data", desc: true }],
          take: 1
        });

        if (result && result.length > 0) {
          this.eurRate = result[0].Curs || 1;
          console.log("EUR Exchange Rate fetched:", this.eurRate);
          // Refresh grid to update calculations if needed
          if (this.$refs.dataGrid && this.$refs.dataGrid.instance) {
            this.$refs.dataGrid.instance.refresh();
          }
        }
      } catch (error) {
        console.error("Error fetching EUR rate:", error);
      }
    },
  },

  mounted() {
    this.createODataContext();
    this.loadClase();
    this.fetchEurRate();
    this.setDeleteConfirmationMessage();

    if (this.autoAdd && !this.isLocked) {
      setTimeout(() => {
        this.onAddClick();
      }, 500);
    }

    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      }
    });

    locale('ro');
  },
});
</script>
<style scoped lang="scss">
/* Column chooser button */
:deep(.dx-datagrid-column-chooser-button),
:deep(.dx-datagrid-toolbar-button.dx-datagrid-column-chooser-button) {
  width: 30px !important;
  height: 30px !important;
  min-width: 30px !important;
  min-height: 30px !important;
  padding: 0 !important;
}

/* iconul din buton */
:deep(.dx-datagrid-column-chooser-button .dx-icon) {
  font-size: 15px !important;
}

/* Search panel: container + input */
:deep(.dx-datagrid-search-panel) {
  height: 30px !important;
}

:deep(.dx-datagrid-search-panel .dx-texteditor),
:deep(.dx-datagrid-search-panel .dx-texteditor-container) {
  height: 30px !important;
  min-height: 30px !important;
}

:deep(.dx-datagrid-search-panel input.dx-texteditor-input) {
  height: 30px !important;
  padding: 4px 8px !important;
  font-size: 13px !important;
}


/* Export button */
:deep(.dx-datagrid-export-button),
:deep(.dx-datagrid-toolbar-button.dx-datagrid-export-button) {
  width: 30px !important;
  height: 30px !important;
  min-width: 30px !important;
  min-height: 30px !important;
  padding: 0px !important;
  margin-top: -10px !important;
  border-radius: 100% !important;
}

/* icon export */
:deep(.dx-datagrid-export-button .dx-icon) {
  font-size: 15px !important;
}

.details-scroll-view {
  background-color: #f8f9fc;
}

.details-container {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Header Context */
.popup-header--products {
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
}

/* Stats Row */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.dx-datagrid-toolbar .dx-button {
  min-width: 30px;
  height: 30px;
}


.stat-card {
  background: white;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
}

.stat-icon {
  font-size: 24px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f1f5f9;
  color: #475569;
}

.stat-card--quantity .stat-icon {
  background: #eff6ff;
  color: #2563eb;
}

.stat-card--price .stat-icon {
  background: #fdf2f8;
  color: #db2777;
}

.stat-card--total .stat-icon {
  background: #ecfdf5;
  color: #059669;
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  font-weight: 600;
}

.stat-value {
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  margin-top: 2px;
}

/* Info Sections */
.info-sections-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.info-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-section-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.section-header {
  padding: 14px 16px;
  background: #fcfcfd;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  color: #334155;
  font-size: 14px;
}

.section-icon {
  color: #64748b;
  font-size: 18px;
}

.info-list {
  padding: 10px 0;
}

.info-item {
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    font-size: 11px;
    color: #94a3b8;
    text-transform: uppercase;
    font-weight: 600;
  }

  .value {
    font-size: 14px;
    color: #334155;
    font-weight: 500;

    &.multiline {
      line-height: 1.5;
      font-style: italic;
      color: #475569;
    }

    &.highlight {
      color: #2563eb;
    }

    &.success {
      color: #059669;
    }
  }
}

/* Status Chips */
.status-chip {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);

  &--active {
    background: #ecfdf5;
    color: #065f46;
    border-color: #6ee7b7;
  }
}

/* Metadata */
.system-meta-card {
  background: #f1f5f9;
  border-radius: 10px;
  padding: 12px 20px;
}

.meta-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #64748b;
}

.meta-icon {
  font-size: 14px;
}

.meta-separator {
  width: 1px;
  height: 14px;
  background: #cbd5e1;
}

/* Base popup styles restored */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
  color: #fff;
}

.popup-header-main {
  display: flex;
  align-items: center;
  gap: 10px;
}

.popup-header-icon {
  font-size: 20px;
}

.popup-header-texts {
  display: flex;
  flex-direction: column;
}

.popup-header-title {
  font-size: 15px;
  font-weight: 700;
}

.popup-header-subtitle {
  font-size: 12px;
  opacity: 0.85;
}

.popup-header-meta {
  display: flex;
  align-items: center;
}

.popup-body-simple {
  padding: 20px;
}

.popup-body-modern {
  padding: 14px 18px 56px 18px;

}


.form-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.footer-fixed {
  position: sticky;
  bottom: 0;
  padding: 10px 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  z-index: 10;
}

.footer-right .dx-button {
  margin-left: 8px;
}
</style>